import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { LogisticElementModel } from '../../model/contracts'
import { LogisticElementFilterModel } from './model/logisticElements'

export const apiGetLogisticElements = async (
  filter: LogisticElementFilterModel
): Promise<LogisticElementModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  const request = filter
  return await AxiosInstance.post(
    // `https://localhost:59923/api/LogisticElements`,
    `${apiSuffixUrl}/api/LogisticElements`,
    filter
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}
